
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","height":"16","width":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#000000","fill":"none","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M1 6.496l7-6 7 6","stroke-width":"1.000005"}}),_c('path',{attrs:{"d":"M8 3.496l-5.749 4.91A.792.792 0 002 8.94v5.903c.001.36.293.651.652.652H6.5v-4.673c0-.18.146-.326.326-.327h2.348c.18.001.325.147.326.327v4.673h3.848a.654.654 0 00.652-.651V8.941a.792.792 0 00-.251-.534L8 3.496z","stroke-width":"1.000005"}})])])
          )
        }
      }
    